/* Alma Velari: sorteo del carrusel "Asi sientan nuestras prendas".
 *
 * La seccion pinta las 59 fotos; aqui se quedan veinte y se esconde el resto.
 *
 * El sorteo no es un barajado suelto. Si lo fuera saldrian dos fotos de la
 * misma prenda pegadas una de cada tres veces, y eso es justo lo que hace que
 * un carrusel parezca corto. En vez de eso se reparte por rondas: se barajan
 * las familias, se baraja dentro de cada familia, y luego se va cogiendo una
 * de cada familia por vuelta. Con quince familias, dos fotos de la misma
 * prenda quedan como minimo a quince tarjetas de distancia, o sea nunca a la
 * vista a la vez.
 *
 * Las que no entran se ocultan con display:none y no llegan a descargarse,
 * porque van con loading="lazy" y la seccion esta fuera de pantalla al cargar.
 *
 * Se usa "order" de flexbox en lugar de mover nodos: reordenar el DOM de un
 * contenedor con scroll-snap mientras el navegador ya lo ha medido provoca un
 * salto visible. Con "order" el navegador lo resuelve en el mismo reflujo.
 */
class AvUgc extends HTMLElement {
  connectedCallback() {
    if (this.dataset.listo) return;
    this.dataset.listo = '1';

    const lista = this.querySelector('.av-ugc__lista');
    if (!lista) return;
    const todas = Array.from(lista.children);
    const cuantas = Math.min(parseInt(this.dataset.cuantas, 10) || 20, todas.length);

    // agrupar por prenda
    const familias = new Map();
    todas.forEach((li) => {
      const f = li.dataset.fam || '';
      if (!familias.has(f)) familias.set(f, []);
      familias.get(f).push(li);
    });

    const barajar = (a) => {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    };

    const grupos = barajar(Array.from(familias.values())).map(barajar);

    // una de cada familia por vuelta, hasta llegar a las que se piden
    const elegidas = [];
    for (let vuelta = 0; elegidas.length < cuantas; vuelta++) {
      let hubo = false;
      for (const g of grupos) {
        if (vuelta < g.length) {
          elegidas.push(g[vuelta]);
          hubo = true;
          if (elegidas.length === cuantas) break;
        }
      }
      if (!hubo) break; // no quedan fotos: se muestran todas las que hay
    }

    const dentro = new Set(elegidas);
    todas.forEach((li) => {
      if (!dentro.has(li)) li.style.display = 'none';
    });
    elegidas.forEach((li, i) => {
      li.style.order = i;
    });

    this.classList.add('av-ugc--sorteado');
  }
}

if (!customElements.get('av-ugc')) customElements.define('av-ugc', AvUgc);
